import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { UnauthorizedFunction } from '../../utils/UtilsFunction';

// Async thunk to fetch tutorial data
export const get_tutorial_data = createAsyncThunk(
  'tutorial/get_tutorial_data',
  async (category, { rejectWithValue }) => {
    try {
      // Map URL category to API category (e.g., getting_started -> Getting Started)
      const apiCategory =
        category === 'getting_started'
          ? 'Getting Started'
          : category.replace('_', ' ');

      const token = localStorage.getItem('token'); // Retrieve token from local storage

      if (!token) {
        return rejectWithValue('No authentication token found');
      }

      // API call to fetch tutorial data
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}tutorials?category=${encodeURIComponent(apiCategory)}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`, // Use Bearer token
          },
        }
      );

      const res = await response.json();

      if (!res.success) {
        UnauthorizedFunction(res); // Handle unauthorized access
        return rejectWithValue(res.message || 'Unauthorized'); // Return string
      }

      return res;
    } catch (error) {
      console.error('Error fetching tutorial data:', error);
      return rejectWithValue(error.message || 'Failed to fetch tutorials'); // Return string
    }
  }
);

const tutorialSlice = createSlice({
  name: 'tutorial',
  initialState: {
    tutorial_data: [],
    tutorial_loading: false,
    tutorial_error: null,
    total_count: 0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(get_tutorial_data.pending, (state) => {
        state.tutorial_loading = true;
        state.tutorial_error = null;
      })
      .addCase(get_tutorial_data.fulfilled, (state, action) => {
        state.tutorial_loading = false;
        state.tutorial_data = action.payload.success
          ? [{ data: action.payload.tutorials }]
          : [];
        state.total_count = action.payload.success
          ? action.payload.totalTutorials
          : 0;
      })
      .addCase(get_tutorial_data.rejected, (state, action) => {
        state.tutorial_loading = false;
        state.tutorial_error = action.payload; // Payload is a string
      });
  },
});

export default tutorialSlice.reducer;
